import Vue from 'vue'
import marked from 'marked'

Vue.filter('markdown', (text, inline = true) => {
  if (text) {
    return marked(text)
  }
  return text
})

Vue.filter('resize', (image, bound = 768, options = '') => {
  function getNaturalSize() {
    const arr = image.split('/').filter((word) => word !== '')
    const sizes = arr[3].split('x')
    return {
      width: parseInt(sizes[0], 10),
      height: parseInt(sizes[1], 10),
    }
  }

  if (image.length > 0) {
    let width = 0
    let height = 0
    const imgWidth = getNaturalSize().width
    const imgHeight = getNaturalSize().height
    const smart = options.smart ? '/smart' : ''
    const filter = options.quality ? options.quality : ''

    if (options.isHScreen && imgWidth > imgHeight && bound < 720) {
      height = Math.round(bound * (16 / 9))
      width = bound

      // fallback if image is not tall enough
      if (height > imgHeight) {
        height = imgHeight
        width = Math.round((height / 16) * 9)
      }
    } else if (imgWidth > imgHeight) {
      // landscape
      const ratio = imgHeight / imgWidth
      height = Math.round(bound * ratio)
      width = bound
    } else if (imgWidth < imgHeight) {
      // portrait
      const ratio = imgWidth / imgHeight
      height = bound
      width = Math.round(bound * ratio)
    } else {
      // square
      height = bound
      width = bound
    }

    return `//img2.storyblok.com/${width}x${height}${smart}${filter}${image.replace(
      '//a.storyblok.com',
      ''
    )}`
  }
  return null
})

Vue.filter('dashify', (value) => {
  if (typeof value === 'undefined') {
    return 'undefined'
  }
  const dashified = value
    .toString()
    .replace(/([A-Z])/g, ' $1')
    .trim()
    .toLowerCase()
    .replace(/[ _]/g, '-')

  return `blok-${dashified}`
})

Vue.filter('monthName', (value) => {
  const month = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ]

  return month[value]
})
